import React, { useState } from 'react';
import '../css/contact.css';
import Seo from './Seo';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck, faEnvelope, faPaperPlane } from '@fortawesome/free-solid-svg-icons';

const email = 'contact@nicocarr.ca';

// Regex pour valider le courriel
const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

function Contact() {
  const [state, setState] = useState({ email: '', message: '' });
  const [errors, setErrors] = useState({ email: '', message: '' });
  const [sent, setSent] = useState(false);

  function handleChange(event) {
    const { name, value } = event.target;
    setState((prev) => ({ ...prev, [name]: value }));
    setErrors((prev) => ({ ...prev, [name]: '' }));
  }

  // Valider les champs avant d'ouvrir l'application de courriel
  function validate() {
    const newErrors = { email: '', message: '' };
    if (!emailRegex.test(state.email.trim())) newErrors.email = 'Please enter a valid email address.';
    if (state.message.trim() === '') newErrors.message = 'Please write a message.';
    setErrors(newErrors);
    return !newErrors.email && !newErrors.message;
  }

  // Ouvre l'application de courriel avec le message déjà rempli
  function submit(event) {
    event.preventDefault();
    if (!validate()) return;

    const subject = `Portfolio contact from ${state.email.trim()}`;
    const body = `${state.message.trim()}\n\nReply to: ${state.email.trim()}`;
    window.location.href = `mailto:${email}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
    setSent(true);
  }

  function reset() {
    setState({ email: '', message: '' });
    setSent(false);
  }

  return (
    <div className="wrapper">
      <Seo
        title="Contact"
        path="/contact"
        description="Contact Nicolas Carriere, bilingual (French/English) computer programmer in Ontario, by email at contact@nicocarr.ca."
      />
      <div className="contact-container">
        <h1>Contact Me</h1>

        {sent ? (
          <div className="contact-confirm">
            <div className="contact-confirm-icon"><FontAwesomeIcon icon={faCheck} /></div>
            <p className="contact-text">
              Thanks! Your email app should now be open with your message ready. Just press send to reach me.
            </p>
            <p className="contact-small">
              <FontAwesomeIcon icon={faEnvelope} /> Nothing opened? Email me directly at <a href={`mailto:${email}`}>{email}</a>.
            </p>
            <button type="button" className="contact-button" onClick={reset}>Write another message</button>
          </div>
        ) : (
          <form onSubmit={submit} noValidate>
            <div className="form-group">
              <label htmlFor="email">Your email</label>
              <input
                type="email"
                id="email"
                name="email"
                value={state.email}
                onChange={handleChange}
                className={errors.email ? 'is-invalid' : ''}
                placeholder="you@example.com"
              />
              {errors.email && <div className="invalid-feedback">{errors.email}</div>}
            </div>
            <div className="form-group">
              <label htmlFor="message">Message</label>
              <textarea
                id="message"
                name="message"
                rows="6"
                value={state.message}
                onChange={handleChange}
                className={errors.message ? 'is-invalid' : ''}
                placeholder="Hi Nicolas, ..."
              />
              {errors.message && <div className="invalid-feedback">{errors.message}</div>}
            </div>
            <button type="submit" className="contact-button">
              <FontAwesomeIcon icon={faPaperPlane} /> Send
            </button>
            <p className="contact-small">
              <FontAwesomeIcon icon={faEnvelope} /> Or email me directly at <a href={`mailto:${email}`}>{email}</a>
            </p>
          </form>
        )}
      </div>
    </div>
  );
}

export default Contact;
